var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    {
      staticClass: "yxtbiz-certificate-preview hand",
      on: { click: _vm.preview },
    },
    [
      _c("yxt-image", {
        ref: "imgPreview",
        staticClass: "yxtbiz-certificate-preview__previewer",
        attrs: {
          src: _vm.previewUrl,
          "preview-src-list": [_vm.previewUrl],
          fit: "contain",
        },
      }),
      _vm._t("default"),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }